import { useTranslation } from "next-i18next";
import React from "react";
import Button from "../../Button";

interface CompletedProps {
  nextLink: string;
}

function Completed({ nextLink }: CompletedProps) {
  const { t } = useTranslation("classroom");

  return (
    <div className="w-full flex flex-col sm:flex-row md:flex-col lg:flex-row sm:items-center md:items-start lg:items-center gap-6 place-content-between">
      <div className="bodyText">{t("classroomCompleted")}</div>
      <Button
        label={t("whatsNext")}
        link={nextLink}
        svgIcon="arrow-bottom-white"
        type="withWhiteBorder"
        className="sm:hidden md:flex lg:hidden"
        stretch
        nowrap
      />
      <Button
        label={t("whatsNext")}
        link={nextLink}
        svgIcon="arrow-bottom-white"
        type="withWhiteBorder"
        className="hidden sm:flex md:hidden lg:flex w-auto"
        nowrap
      />
    </div>
  );
}

export default Completed;
